// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Firebase projenin gerçek bilgileri ile değiştir
const firebaseConfig = {
  apiKey: "AIzaSyBtZoGGs1yaJmuS34lIdbwY1y03UGTNcmY",
  authDomain: "organizasyon-panel.firebaseapp.com",
  projectId: "organizasyon-panel",
  storageBucket: "organizasyon-panel.appspot.com",
  messagingSenderId: "508597420846",
  appId: "1:508597420846:web:bce447b3fd34b8fb8efb0f",
  measurementId: "G-Z9I7R75LJM"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);
